<template>
  <v-card flat>
    <v-toolbar flat color="white">
      <v-toolbar-title>Group Fees Overview</v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="$emit('refresh')">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="denormalizedGroups"
      dense
      class="elevation-1"
      sort-by="orderOnUi"
      sort-desc="true"
    >
      <template v-slot:item.trainingFees="{ item }">
        <div v-if="item.trainingFees.length">
          <div
            v-for="(fee, index) in item.trainingFees"
            :key="index"
          >
            {{ fee.notes || '' }}<span v-if="fee.notes"> —</span> {{ formatCurrency(fee.amount) }} <span class="grey--text text--darken-1">({{ fee.billingFrequency }})</span>
          </div>
        </div>
        <span v-else>-</span>
      </template>

      <template v-slot:item.registrationFee="{ item }">
        {{ formatCurrency(item.registrationFee) }}
      </template>

      <template v-slot:item.volunteerFee="{ item }">
        {{ formatCurrency(item.volunteerFee) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: {
    groupEdges: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: "Group Name", value: "teamName" },
        { text: "Club Fees", value: "trainingFees" },
        { text: "Registration Fee ($)", value: "registrationFee" },
        { text: "Volunteer Fee ($)", value: "volunteerFee" },
        { text: "Visibility", value: "visibility" },
      ],
      denormalizedGroups: [],
    };
  },
  watch: {
    groupEdges: {
      immediate: true,
      handler(newEdges) {
        this.denormalizedGroups = this.denormalize(newEdges);
      },
    },
  },
  methods: {
    denormalize(edges) {
      return edges.map(({ node }) => {
        const fees = (node.fees.edges || []).map(e => e.node);

        return {
          ...node,
          trainingFees: fees.filter(f => f.feeType === 'training'),
          registrationFee: (fees.find(f => f.feeType === 'registration') || {}).amount || null,
          volunteerFee: (fees.find(f => f.feeType === 'volunteer') || {}).amount || null,
        };
      });
    },
    formatCurrency(value) {
      return value != null ? `$${value.toFixed(2)}` : "-";
    },
  },
};
</script>
